import { createFileRoute } from '@tanstack/react-router';
import { NewProject } from '@/features/projects';

export const Route = createFileRoute('/projects/new')({
  component: NewProject,
});
